import React, { useRef } from "react";
import { Link } from "react-router-dom";
import { products } from "../../data/products";

const TrendingProducts = () => {
  const sliderRef = useRef(null);

  const slideLeft = () => {
    sliderRef.current.scrollLeft -= 320;
  };

  const slideRight = () => {
    sliderRef.current.scrollLeft += 320;
  };

  return (
    <section className="trending-section">
      <span className="mini-title">Product</span>
      <h2 className="main-title">Our Top Product</h2>

      <div className="slider-wrapper">
        <button className="slider-btn left" onClick={slideLeft}>
          &#10094;
        </button>

        <div className="trending-slider" ref={sliderRef}>
          {products.map((item) => (
            <div className="product-card" key={item.id}>
              
              {/* Image */}
              <Link to={`/products/${item.slug}`} className="product-img">
                <img src={item.img} alt={item.name} />
              </Link>

              {/* Info */}
              <div className="product-info">
                <h4>
                  <Link to={`/products/${item.slug}`} className="product-link">
                    {item.name}
                  </Link>
                </h4>

                <div className="price-row">
                  <span className="new-price">Rs.{item.price}</span>
                  {item.oldPrice && (
                    <span className="old-price">Rs.{item.oldPrice}</span>
                  )}
                </div>

                {/* ✅ FIXED BUY NOW BUTTON */}
                <Link
                  to={`/products/${item.slug}`}
                  className="cart-btn"
                >
                  Buy Now
                </Link>
              </div>
            </div>
          ))}
        </div>

        <button className="slider-btn right" onClick={slideRight}>
          &#10095;
        </button>
      </div>
    </section>
  );
};

export default TrendingProducts;
